"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.waitForExpected = void 0;
const tslib_1 = require("tslib");
const iotv_v3_types_1 = require("@iotv/iotv-v3-types");
const chalk_1 = tslib_1.__importDefault(require("chalk"));
const internal_config_1 = require("internal-config");
/**
 * Utility to repeatedly run a function (perhaps against an API) until the expected result is returned or maxDurationMs.
 * Eg; for eventual consistency tests
 */
const { region, stage, projectCode } = internal_config_1.Environment;
const waitForExpected = async ({ fn, p, expected, maxDurationMs, initialWaitMs }) => {
    const backOff = 1.1;
    let currentWait = initialWaitMs ?? iotv_v3_types_1.Milliseconds.SECOND;
    const t0 = Date.now();
    let gotExpected = false;
    let iterations = 0;
    while (Date.now() - t0 < maxDurationMs) {
        const res = await fn(p);
        if (typeof expected === 'function') {
            const validator = expected;
            gotExpected = validator(res);
            if (gotExpected === true) {
                console.log(`Got expected = ${gotExpected} from validator in ${iterations} iterations and ${(Date.now() - t0) / iotv_v3_types_1.Milliseconds.SECOND} secs`);
            }
        }
        else {
            if (res || (0, iotv_v3_types_1.isNonNaNNumber)(res) || (0, iotv_v3_types_1.isBoolean)(res)) {
                if ((typeof res === 'number' || typeof expected === 'number')) {
                    if (res === expected) {
                        gotExpected = true;
                        console.log(`Got expected number res ${gotExpected} ( ${expected} = ${res}) in ${iterations} iterations and ${(Date.now() - t0) / iotv_v3_types_1.Milliseconds.SECOND} secs`);
                        break;
                    }
                }
                else if ((0, iotv_v3_types_1.objectsMatch)(res, expected ?? { never: true })) {
                    console.log(`Got expected res ( ${(0, iotv_v3_types_1.getObjectHash)(expected)} = ${(0, iotv_v3_types_1.getObjectHash)(res)}}) in ${iterations} iterations and ${(Date.now() - t0) / iotv_v3_types_1.Milliseconds.SECOND} secs`);
                    gotExpected = true;
                    break;
                }
            }
            else if (!res) {
                if (expected === undefined && res === undefined) {
                    console.log(`Got expected undefied res ( ${expected} = ${res}) in ${iterations} iterations and ${(Date.now() - t0) / iotv_v3_types_1.Milliseconds.SECOND} secs`);
                    gotExpected = true;
                    break;
                }
                else if (expected === null && res === null) {
                    console.log(`Got expected nullish res ( ${expected} = ${res}) in ${iterations} iterations and ${(Date.now() - t0) / iotv_v3_types_1.Milliseconds.SECOND} secs`);
                    gotExpected = true;
                    break;
                }
            }
        }
        iterations++;
        await new Promise((resolve) => setTimeout(resolve, currentWait));
        currentWait *= backOff;
    }
    if (!gotExpected)
        console.log((0, chalk_1.default)(`Failed to get expected res in ${iterations} iterations and ${(Date.now() - t0) / iotv_v3_types_1.Milliseconds.SECOND} secs`));
    return gotExpected;
};
exports.waitForExpected = waitForExpected;
